<app-preloader *ngIf="IsLoadingResults"></app-preloader>
<div>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLabel">Privacy Notice – InTaxGTC</h4>
        </div>
        <div class="modal-body">
            <b> 1.Introduction</b>
            <br />
            This Privacy Notice is intended to describe the practices EY follows in relation to the <b>In TaxGTC</b>  
            with respect to the privacy of all individuals whose personal 
            data is processed and stored in the Tool. 
            <br />
            <b>2.Who manages the Tool?</b>
            <br />
            ”EY” refers to one or more of the member firms of Ernst & Young Global Limited (“EYG”),
             each of which is a separate legal entity and can act as a data controller in its own right.
              The entity that is acting as a data controller by providing this Tool on which your personal data will be processed and stored is Ernst & Young Services Private Limited (EYSPL).
            <br />
            The personal data you provide in the Tool is shared with Ernst & Young Services Private Limited (EYSPL),
             are member firm of EYG (see “Who can access your information” section below).
            <br />
            The Tool is hosted on servers that are located at Ernst & Young Services Private Limited,
             Golf View Tower, Sector 42, Gurugram, Haryana, India.
            <br />
            <b>3. Why do we need your information? </b>
            <br />
            The purpose of In TaxGTC  system is to track and send reminders to engagement managers and engagement partners of total unadjusted advances 
            laying on their engagement codes. Data is uploaded by the Finance team which helps to send the
            reminders on basis of unadjusted advance amount.
            <br />
            <b>4. What type of personal data is processed in the Tool? </b>
            <br />
            The Tool processes the following categories of personal data:
            <br />
            - Name (first name, last name)<br />
            - Email address <br />
            Name & email address is sourced from [EY GHR] <br />
            <b>5. Sensitive Personal Data</b>
            <br />
            Sensitive personal data reveals your racial or ethnic origin, political opinions, religious or philosophical
            beliefs, trade union membership, genetic data, biometric data, data concerning health or data concerning sex
            life or sexual orientation.
            <br /> “EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s
            intention is not to process such information.”
            <br />
            <b>6. Who can access your information?</b>
            <br />
            Your personal data is accessed in the Tool by the following persons/teams:<br />
            <br />
            • Admin/User role - This role involves full administrative access i.e., they can upload and view all the records. 
            <br />
            The geographical scope of this system would be India.
            <br />
            The access rights detailed above involve transferring personal data in 
            various jurisdictions (including jurisdictions outside the European Union) 
            in which EY operates (EY office locations are listed at www.ey.com/ourlocations). 
            EY will process your personal data in the Tool in accordance with applicable law and professional regulations in your jurisdiction. Transfers of personal data within the 
            EY network are governed by EY’s Binding Corporate Rules (www.ey.com/bcr).
            <br />
            <b>7. Data retention</b>
            <br />
            The policies and/or procedures for the retention of personal data in the Tool are:
            <br />
            Data retention is in accordance with EY Records Retention Global Policy and the applicable Global, Area,
            Region or Country Retention Schedule. Please provide details of applicable retention period. If you do not
            have these details, please contact the Records and Information Management (RIM) team within Risk Management
            for assistance
            <br />
            Your personal data will be retained in compliance with privacy laws and regulations.
            <br />
            After the end of the data retention period, your personal data will be deleted.
            <br />
            <b>8. Security</b>
            <br />
            EY is committed to making sure your personal data is secure. To prevent unauthorized access or disclosure,
            EY has technical and organizational measures to safeguard and secure your personal data. All EY personnel
            and third parties EY engages to process your personal data are obliged to respect your data’s
            confidentiality.
            <br />
            <b>9. Controlling your personal data</b>
            <br />
            EY will not transfer your personal data to third parties (other than any external parties referred to in
            section 6 above) unless we have your permission or are required by law to do so.
            <br />
            You are legally entitled to request details of EY’s personal data about you.
            <br />
            To confirm whether your personal data is processed in the Tool or to access your personal data in the Tool,
            contact your usual EY representative or email your request to global.data.protection@ey.com .
            <br />
            <b>10. Rectification, erasure, restriction of processing or data portability</b>
            <br />
            You can confirm your personal data is accurate and current. You can request rectification, erasure,
            restriction of processing or a readily portable copy of your personal data by contacting your usual EY
            representative or by sending an e-mail to global.data.protection@ey.com.
            <br />
            <b>11. Complaints</b>
            <br />
            If you are concerned about an alleged breach of privacy law or any other regulation, contact EY’s Global
            Privacy Leader, Office of the General Counsel, 6 More London Place, London, SE1 2DA, United Kingdom or via
            email at global.data.protection@ey.com or via your usual EY representative. An EY Privacy Leader will
            investigate your complaint and provide information about how it will be handled and resolved.
            <br />If you are not satisfied with how EY resolved your complaint, you have the right to complain to your
            country’s data protection authority. You can also refer the matter to a court of competent jurisdiction.
            <br />
            <br /><b>12. Contact us</b>
            <br />
            If you have additional questions or concerns, contact your usual EY representative or email
            global.data.protection@ey.com.
            <br />
            <div class="row">
                
                <div class="form-group col-md-2">
                    <p-checkbox [(ngModel)]="IsConsentAgreed" [binary]="true" inputId="ny" value="I Agree"></p-checkbox>
                    &nbsp;&nbsp;<label for="ny">I Agree</label>
                </div>
                <div class="form-group col-md-2">
                    <button mat-raised-button class="btn-primary1" type="button" (click)="ConfirmPrivacyNotice()"
                        [disabled]="!IsConsentAgreed">Submit Consent</button>
                </div>
            </div>
            <br />
            <br />
        </div>
    </div>
</div>